<template>
    <div class="portfolioOverviewSummary">
        <div class="title">{{ $t('portfoliosOverview.title') }}</div>
        <div class="summary">
            <div class="currency">{{ userPreferredCurrency }}</div>
            <div class="total">{{ allPortfoliosTotal }}</div>
        </div>
        <div class="sections">
            <div class="section">
                <div class="desc">{{ totalDayChangeTitle }}</div>
                <div class="value">
                    <GainLoseDisplayer :value="totalChange.val" :dark="true"></GainLoseDisplayer>
                </div>
            </div>
            <div class="section">
                <div class="desc">{{ totalGainTitle }}</div>
                <div class="value">
                    <GainLoseDisplayer :value="totalGain" :dark="true"></GainLoseDisplayer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GainLoseDisplayer from '../../components/controls/GainLoseDisplayer.vue';
import DashboardOverviewMixin from '../../components/home/dashboard/DashboardOverviewMixin';

export default {
	components: { GainLoseDisplayer },
    mixins: [DashboardOverviewMixin],
    computed: {
        totalDayChangeTitle() {
            return this.$t('portfoliosOverview.summary.totalDayChange') + ` (${this.userPreferredCurrency})`;
        },
        totalGainTitle() {
            return this.$t('portfoliosOverview.summary.totalGain') + ` (${this.userPreferredCurrency})`;
        },
        aggregatedPortfolioStock() {
            return this.$store.getters.aggregatedPortfolioStock;
        },
        totalGain() {
            return this.aggregatedPortfolioStock.reduce((acc, stock) => {
                return acc + (stock.statistics.normalizedWithPreferredCurrency.totalProfitIncludingUnrealized || 0)
            }, 0);
        }
    }
}
</script>

<style lang="scss" scoped>
.portfolioOverviewSummary {
    display: flex;
    align-items: center;
    gap: 30px;
    background-color: var(--v-darkBG-base);
    color: #FFF;
    padding: 15px 20px;
    .title {
        font-size: 1.5rem;
        font-weight: bold;
    }
    .summary {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 2rem;
        font-weight: bold;
        flex: 1;
        .currency {
            font-size: 0.8rem;
            color: var(--v-lightBorder-base);
        }
    }
    .sections {
        display: flex;
        align-items: center;
        gap: 60px;
        .section {
            display: flex;
            flex-direction: column;
            gap: 5px;
            .desc {
                font-size: 0.8rem;
                text-align: right;
            }
            .value {
                font-size: 1.2rem;
                font-weight: bold;
                text-align: right;
            }
        }
    }
}
</style>